var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.96,10.703c-0.293-0.293-0.768-0.293-1.061,0l-1.403,1.403c0-0.035,0.005-0.069,0.005-0.104c0-4.136-3.364-7.5-7.5-7.5 s-7.5,3.364-7.5,7.5s3.364,7.5,7.5,7.5c1.845,0,3.618-0.676,4.992-1.903c0.31-0.276,0.336-0.75,0.061-1.059 c-0.276-0.31-0.751-0.338-1.059-0.061c-1.1,0.981-2.519,1.522-3.994,1.522c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6 c0,0.02-0.003,0.04-0.003,0.06l-1.359-1.359c-0.293-0.293-0.768-0.293-1.061,0s-0.293,0.768,0,1.061l2.658,2.658 c0.146,0.146,0.338,0.22,0.53,0.22c0.098,0,0.195-0.02,0.287-0.058c0.092-0.037,0.178-0.091,0.252-0.166l2.653-2.654 C22.253,11.47,22.253,10.996,21.96,10.703z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.7c03d66a1638a1991f3cc4cdb4c16a37.svg";
export { ForwardRef as ReactComponent };